'use client';

import Cookies from 'js-cookie';
import { useCallback, useState } from 'react';
import { Country } from '@/helpers/conf';
import { CLIENT_ENVS } from '@/helpers/constants';
import { fetcherInternal, fetcherSS } from '@/modules/api/fetcher';
import { useGetCommonStore } from '@/store';

interface IPromoStagResponse {
  stag: string | null;
}

const DEFAULT_ORGANIC_STAG = '241395_6994262897c1b7958b934fdd';

const syncStagToProject = async (stagValue: string): Promise<void> => {
  try {
    await fetcherSS(`/info/project?stag=${stagValue}`);
  } catch (error) {
    console.error('Error syncing stag to project:', error);
  }
};

export const useOrganicStag = () => {
  const useCommonStore = useGetCommonStore();
  const countryCode = useCommonStore.use.countryCode();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const [stag, setStag] = useState<string | null>(null);

  const syncStag = useCallback(async () => {
    if (!CLIENT_ENVS.ORGANIC_PROMO_URL) return null;

    const stagFromCookies = Cookies.get('stag');
    const isTargetCountry = [
      Country.Australia,
      Country.Austria,
      Country.Ireland,
    ].includes(countryCode as Country);

    if (!(isTargetCountry && isMobileDevice) || stagFromCookies) return null;
    if (stag) return stag;

    let stagValue = DEFAULT_ORGANIC_STAG;

    try {
      const data = await fetcherInternal<IPromoStagResponse>('/stag-info');
      if (data.stag) {
        stagValue = data.stag;
      }
    } catch (error) {
      console.error('Error fetching stag:', error);
    }

    await syncStagToProject(stagValue);
    setStag(stagValue);

    return stagValue;
  }, [countryCode, isMobileDevice, stag]);

  return { stag, syncStag };
};
